export default "__VITE_ASSET__pRRBp11E__"